import React, { useMemo } from 'react';
import { TabsOption } from 'global';
import { useHistory, useLocation } from 'react-router-dom';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { ListOfMenuTemplates } from 'modules/aftermarketMenuConstructor';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { AftermarketPageTabs } from 'modules/aftermarketMenuConstructor/types';
import { ListAftermarketProducts, AftermarketProductsDashboard } from 'modules/aftermarket';

export const AftermarketPage = () => {
  const history = useHistory();
  const location = useLocation();

  const initialTab = useMemo(() => {
    const tabsByPathname: Record<string, AftermarketPageTabs> = {
      '/aftermarket': AftermarketPageTabs.Products,
      '/aftermarket/menu': AftermarketPageTabs.MenuTemplates,
      '/aftermarket/dashboard': AftermarketPageTabs.Dashboard,
    };

    return tabsByPathname[location.pathname] ?? AftermarketPageTabs.Products;
  }, [location.pathname]);

  const handleChangeTab = (newValue: AftermarketPageTabs) => {
    const routesByType: Record<AftermarketPageTabs, string> = {
      [AftermarketPageTabs.Products]: '/aftermarket',
      [AftermarketPageTabs.MenuTemplates]: 'aftermarket/menu',
      [AftermarketPageTabs.Dashboard]: 'aftermarket/dashboard',
    };

    history.push(routesByType[newValue]);
  };

  const tabs: TabsOption<AftermarketPageTabs>[] = [
    {
      isVisible: true,
      label: AftermarketPageTabs.Products,
      value: AftermarketPageTabs.Products,
      component: <ListAftermarketProducts />,
    },
    {
      isVisible: true,
      label: AftermarketPageTabs.MenuTemplates,
      value: AftermarketPageTabs.MenuTemplates,
      component: <ListOfMenuTemplates />,
    },
    {
      isVisible: false,
      label: AftermarketPageTabs.Dashboard,
      value: AftermarketPageTabs.Dashboard,
      component: <AftermarketProductsDashboard />,
    },
  ];

  return (
    <PageContainer title="Aftermarket">
      <TabsContainer<AftermarketPageTabs>
        tabs={tabs}
        initialTab={initialTab}
        onTabChange={handleChangeTab}
        TabsLabelWrapper={CardBackground}
      />
    </PageContainer>
  );
};
